import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, catchError } from 'rxjs/operators';
import { PagedInvoices, Invoice, InvoiceFilters } from '../models/invoices.model';


@Injectable({
  providedIn: 'root'
})
export class InvoicesService {
    private url = `${environment.apiUrl}/payments_support/invoices`;
    private urlUpdate = `${environment.apiUrl}/payments_support/update_invoice_payment_link`;

    constructor(private http: HttpClient) {}

    getInvoices(filters: InvoiceFilters): Observable<PagedInvoices> {
        // Solo agrega los filtros si tienen valor útil
        const params: { [param: string]: string } = {};
        Object.entries(filters).forEach(([key, value]) => {
            if (
                value !== undefined &&
                value !== null &&
                value !== '' &&
                !(typeof value === 'boolean' && value === false)
            ) {
                params[key] = String(value);
            }
        });
        return this.http.get<PagedInvoices>(this.url, { params });
    }

    

    createInvoices(filters: InvoiceFilters): Observable<PagedInvoices> {
        const payload = {
            from_date: filters.from_date,
            to_date: filters.to_date
        };
        return this.http.post<PagedInvoices>(this.url, payload);
    }

    updateInvoice(invoice_id: number, data: { payment_link_url?: string }): Observable<Invoice> {
        return this.http.post<Invoice>(`${this.urlUpdate}/${invoice_id}`, data);
    }

    getInvoiceHtml(invoiceId: number): Observable<string> {
    return this.http.get(
        `${environment.apiUrl}/payments_support/invoices/render/${invoiceId}`,
        { responseType: 'text' }
    );
}
    getInvoiceById(id: number): Observable<Invoice> {
        return this.http.get<Invoice>(`${this.url}/${id}`).pipe(
            tap(invoice => {
                if (!invoice) {
                    throw new Error('Invoice not found');
                }
            }),
            catchError(error => {
                console.error('Error fetching invoice:', error);
                throw error;
            })
        );
    }

    renderInvoiceHtml(invoiceId: number): Observable<string> {
        return this.http.get(
            `${environment.apiUrl}/payments_support/invoices/render/${invoiceId}`,
            { responseType: 'text' }
        )
    }

    updateServicePrice(invoiceId: number, serviceId: number, newPrice: number) {
        const url = `${this.url}/${invoiceId}/update_service_price`;
        return this.http.post<Invoice>(url, { service_id: serviceId, new_price: newPrice });
    }

    updateInvoiceReference(invoice_id: number, payment_reference_number: string): Observable<Invoice> {
        return this.http.post<Invoice>(`${this.url}/${invoice_id}/update_reference`, { payment_reference_number });
    }

    regenerateInvoice(invoiceId: number): Observable<Invoice> {
        return this.http.post<Invoice>(`${this.url}/${invoiceId}/regenerate`, {});
    }

    recalculateInvoicesByRange(from_date: string, to_date: string): Observable<any> {
        const payload = { from_date, to_date };
        return this.http.post<any>(`${environment.apiUrl}/payments_support/invoices/recalculate`, payload);
    }

    recalculateInvoiceById(invoice_id: number): Observable<any> {
        const payload = { invoice_id };
        return this.http.post<any>(`${environment.apiUrl}/payments_support/invoices/recalculate`, payload);
    }
}
